import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import * as echarts from 'echarts' // 在import的后面，echarts的前面加一个 * as
Vue.prototype.$echarts = echarts

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar)


new Vue({
  render: h => h(App),
}).$mount('#app')
